/**
 * 로그 관리 설정
 *
 * @since 2018-10-24
 * @author jupil.Go <devp018>
 */

import {i18n} from '~/plugins/i18n'
import {CmApiPrefix as apiPrefix} from '~/utils/restApi'
import Moment from 'moment'

const DATE_FORMAT = 'YYYY-MM-DD'

const initLogMgmtPageData = () => {
  return {
    device_list: [],
    log_mng_cm_id: 0,
    log_mng_cm_sync_yn: 1,
    log_mng_cm_uname: '',
    log_mng_cm_desc: '',
    log_mng_cm_backup_sync_yn: 0,
    log_mng_cm_backup_start_hour: 0,
    log_mng_cm_backup_start_min: 0,
    log_mng_cm_backup_end_hour: 0,
    log_mng_cm_backup_end_min: 0,
    log_mng_cm_retry_ftp_upload_cnt: 3,
    log_mng_cm_delete_ref_retention: 0,
    log_mng_cm_delete_sync_yn: 0,
    log_mng_cm_delete_use_yn: 0,
    log_mng_cm_delete_retent_term: 0,
    log_mng_cm_delete_run_hour: 0,
    log_mng_cm_delete_run_min: 0,
    log_mng_cm_usage_sync_yn: 0,
    log_mng_cm_usage_max_cnt: 90,
    log_mng_cm_log_sync_set: [1, 1],
    log_mng_cm_log_set: [],
    log_mng_cm_log_opt_set: [],
    log_mng_cm_device_model_type: 20
  }
}

const initAutoBackupData = ({id = 0, ccFlag = false, agentTime} = {}) => {
  return {
    log_mng_cm_id: id,
    log_mng_cm_backup_server_id: 0,
    log_mng_cm_backup_server_use_yn: 0,
    log_mng_cm_backup_server_prtc_type: ccFlag ? 1 : 0, // 0:ftp, 1: sftp
    log_mng_cm_backup_server_file_format: 'sdb',
    log_mng_cm_backup_server_method: 0,
    log_mng_cm_backup_server_addr_val: '',
    log_mng_cm_backup_server_port: ccFlag ? 22 : 21,
    log_mng_cm_backup_server_start_date: agentTime ? Moment(agentTime).add(-1, 'days').format(DATE_FORMAT) : '',
    log_mng_cm_backup_server_end_date: agentTime ? Moment(agentTime).add(-1, 'days').format(DATE_FORMAT) : '',
    log_mng_cm_backup_server_type: 0,
    log_mng_cm_backup_server_term: 1,
    log_mng_cm_backup_server_login_name: '',
    log_mng_cm_backup_server_login_pw: '',
    log_mng_cm_backup_server_dir_val: ''
  }
}

function makeSyncSetData (param) {
  try {
    const data = _.cloneDeep(param)
    const res = {}
    if (_.size(data) > 0) {
      data.forEach((o, index) => {
        res[`sync_set${index + 1}`] = o
      })
    } else {
      return void 0
    }
    return res
  } catch (e) {
    return void 0
  }
}

export const state = () => ({
  url: `${apiPrefix}/log-mng-cm`,
  logMgmtDataList: [],
  logMgmtPageData: initLogMgmtPageData(),
  autoBackupList: [],
  autoBackupData: initAutoBackupData(),
  logInfoList: [],
  defaultList: [],
  defaultOptionList: [],
  syncData: {}
})

export const mutations = {
  initStore (state) {
    state.logMgmtDataList = []
    state.logMgmtPageData = initLogMgmtPageData()
    state.autoBackupList = []
    state.autoBackupData = initAutoBackupData()
    state.logInfoList = []
    state.defaultList = []
    state.defaultOptionList = []
    state.syncData = {}
  },
  clearLogMgmtDialog (state) {
    state.logMgmtPageData = initLogMgmtPageData()
  },
  clearLogMgmtDeviceList (state) {
    state.logMgmtPageData.device_list = []
  },
  clearAutoBackupData (state) {
    state.autoBackupList = []
  },
  clearAutoBackupDialog (state, {ccFlag, agentTime}) {
    state.autoBackupData = initAutoBackupData({
      id: _.cloneDeep(state.logMgmtPageData.log_mng_cm_id),
      ccFlag,
      agentTime
    })
  },
  // 리스트 조회
  setLogMgmtData (state, item) {
    state.logMgmtDataList = _.cloneDeep(item)
  },
  setCmId (state, id) {
    state.logMgmtPageData.log_mng_cm_id = id
    state.autoBackupData.log_mng_cm_id = id
  },
  setSyncData (state, data) {
    state.syncData = _.omit(data, ['name', 'itemIndex', '_itemKey'])
    state.logMgmtPageData.log_mng_cm_log_sync_set = _.cloneDeep(_.values(state.syncData))
  },
  addLogMgmt (state, item) {
    state.logMgmtDataList.push(item)
  },
  // edtLogMgmt: (state, item) => {
  //   state.logMgmtDataList.splice(state.selectedItem.itemIndex, 1, item)
  // },
  // delLogMgmt: (state, itemIndexList) => {
  //   // itemIndexList = itemIndexList.sort().reverse()
  //   itemIndexList = _.sortBy(itemIndexList, 'itemIndex').reverse()
  //   for (const itemIndex of itemIndexList) {
  //     state.logMgmtDataList.splice(itemIndex, 1)
  //   }
  // },
  delLogMgmt (state, itemList) {
    for (const itemKey of itemList.log_mng_cm_id_list) {
      const idx = _.findIndex(state.logMgmtDataList, {log_mng_cm_id: itemKey})
      if (idx >= 0) {
        state.logMgmtDataList.splice(idx, 1)
      }
    }
  },
  setLogMgmtDialog (state, data) {
    const logMgmtSettings = _.cloneDeep(data)

    state.logMgmtPageData.log_mng_cm_id = logMgmtSettings.log_mng_cm_id
    state.logMgmtPageData.log_mng_cm_uname = logMgmtSettings.log_mng_cm_uname
    state.logMgmtPageData.log_mng_cm_desc = logMgmtSettings.log_mng_cm_desc
    state.logMgmtPageData.log_mng_cm_backup_sync_yn = logMgmtSettings.log_mng_cm_backup_sync_yn
    state.logMgmtPageData.log_mng_cm_backup_start_hour = logMgmtSettings.log_mng_cm_backup_start_hour
    state.logMgmtPageData.log_mng_cm_backup_start_min = logMgmtSettings.log_mng_cm_backup_start_min
    state.logMgmtPageData.log_mng_cm_backup_end_hour = logMgmtSettings.log_mng_cm_backup_end_hour
    state.logMgmtPageData.log_mng_cm_backup_end_min = logMgmtSettings.log_mng_cm_backup_end_min
    state.logMgmtPageData.log_mng_cm_retry_ftp_upload_cnt = logMgmtSettings.log_mng_cm_retry_ftp_upload_cnt
    state.logMgmtPageData.log_mng_cm_delete_ref_retention = logMgmtSettings.log_mng_cm_delete_ref_retention
    state.logMgmtPageData.log_mng_cm_delete_sync_yn = logMgmtSettings.log_mng_cm_delete_sync_yn
    state.logMgmtPageData.log_mng_cm_delete_use_yn = logMgmtSettings.log_mng_cm_delete_use_yn
    state.logMgmtPageData.log_mng_cm_delete_retent_term = logMgmtSettings.log_mng_cm_delete_retent_term
    state.logMgmtPageData.log_mng_cm_delete_run_hour = logMgmtSettings.log_mng_cm_delete_run_hour
    state.logMgmtPageData.log_mng_cm_delete_run_min = logMgmtSettings.log_mng_cm_delete_run_min
    state.logMgmtPageData.log_mng_cm_usage_sync_yn = logMgmtSettings.log_mng_cm_usage_sync_yn
    state.logMgmtPageData.log_mng_cm_usage_max_cnt = logMgmtSettings.log_mng_cm_usage_max_cnt
    state.logMgmtPageData.log_mng_cm_sync_yn = logMgmtSettings.log_mng_cm_sync_yn
    state.logMgmtPageData.log_mng_cm_device_model_type = logMgmtSettings.log_mng_cm_device_model_type
    state.logMgmtPageData.device_list = logMgmtSettings.device_list

    state.logMgmtPageData.log_mng_cm_log_sync_set = JSON.parse(data.log_mng_cm_log_sync_set)
    state.syncData = _.cloneDeep(makeSyncSetData(state.logMgmtPageData.log_mng_cm_log_sync_set))

    state.logMgmtPageData.log_mng_cm_log_set = JSON.parse(data.log_mng_cm_log_set)
    state.defaultList = state.logMgmtPageData.log_mng_cm_log_set
    state.logInfoList = _.cloneDeep(state.defaultList)

    state.logMgmtPageData.log_mng_cm_log_opt_set = JSON.parse(data.log_mng_cm_log_opt_set)
    state.defaultOptionList = state.logMgmtPageData.log_mng_cm_log_opt_set
  },
  setLogMgmtOptionList (state, data) {
    state.logMgmtPageData.log_mng_cm_log_opt_set = _.cloneDeep(data)
    state.defaultOptionList = _.cloneDeep(state.logMgmtPageData.log_mng_cm_log_opt_set)
  },
  setLogMgmtDeviceList (state, data) {
    if (_.get(data, ['length'], 0) > 0) {
      state.logMgmtPageData.device_list = _.cloneDeep(data)
    }
  },
  setLogMgmtLogEntitiesSettings (state, payload) {
    state.logMgmtPageData.log_mng_cm_log_set = payload

    state.defaultList = state.logMgmtPageData.log_mng_cm_log_set
    state.logInfoList = _.cloneDeep(state.defaultList)
  },
  // 리스트 조회
  setAutoBackupData (state, item) {
    // state.autoBackupList = item.map(o => {
    //   const listLength = _.size(o.device_list)
    //   let
    //     list = [],
    //     listName = ''
    //   if (listLength > 0) {
    //     list = o.device_list.map(id => id.device_id)
    //     listName = (listLength > 1) ? i18n.t('cmn.deviceTypeText', {name: o.device_list[0].device_uname, cnt: listLength - 1}) : o.device_list[0].device_uname
    //   }
    //   return _.assign(o, { 'device_id_list': list, 'device_list_name': listName })
    // })
    state.autoBackupList = _.cloneDeep(item)
  },
  // edtAutoBackupData: (state, item) => {
  //   state.autoBackupList.splice(state.selectedSendItem.itemIndex, 1, item)
  // },
  // delAutoBackupData: (state, itemIndex) => {
  //   state.autoBackupList.splice(itemIndex, 1)
  // },
  // 리스트 조회

  setAutoBackupDialog (state, data) {
    const autoBackupSettings = _.cloneDeep(data)

    state.autoBackupData.log_mng_cm_id = autoBackupSettings.log_mng_cm_id
    state.autoBackupData.log_mng_cm_backup_server_id = autoBackupSettings.log_mng_cm_backup_server_id
    state.autoBackupData.log_mng_cm_backup_server_use_yn = autoBackupSettings.log_mng_cm_backup_server_use_yn
    state.autoBackupData.log_mng_cm_backup_server_type = autoBackupSettings.log_mng_cm_backup_server_type
    state.autoBackupData.log_mng_cm_backup_server_term = autoBackupSettings.log_mng_cm_backup_server_term
    state.autoBackupData.log_mng_cm_backup_server_prtc_type = autoBackupSettings.log_mng_cm_backup_server_prtc_type
    state.autoBackupData.log_mng_cm_backup_server_file_format = autoBackupSettings.log_mng_cm_backup_server_file_format
    state.autoBackupData.log_mng_cm_backup_server_method = autoBackupSettings.log_mng_cm_backup_server_method
    state.autoBackupData.log_mng_cm_backup_server_addr_val = autoBackupSettings.log_mng_cm_backup_server_addr_val
    state.autoBackupData.log_mng_cm_backup_server_port = autoBackupSettings.log_mng_cm_backup_server_port
    state.autoBackupData.log_mng_cm_backup_server_start_date = Moment(autoBackupSettings.log_mng_cm_backup_server_start_date).format(DATE_FORMAT)
    state.autoBackupData.log_mng_cm_backup_server_end_date = Moment(autoBackupSettings.log_mng_cm_backup_server_end_date).format(DATE_FORMAT)
    state.autoBackupData.log_mng_cm_backup_server_login_name = autoBackupSettings.log_mng_cm_backup_server_login_name
    state.autoBackupData.log_mng_cm_backup_server_login_pw = autoBackupSettings.log_mng_cm_backup_server_login_pw
    state.autoBackupData.log_mng_cm_backup_server_dir_val = autoBackupSettings.log_mng_cm_backup_server_dir_val
  }
}

export const actions = {
  async checkConnection ({commit}, {target}) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      res = await this.$axios.$get(`/api/co/tools/connect?target=${encodeURIComponent(target)}`)
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  // 리스트 조회
  async getLogMgmtData ({commit, state}, { loading = true } = {}) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      const ALL_LOG_MGMT_SETTINGS = 0
      res = await this.$axios.$get(`${state.url}/${ALL_LOG_MGMT_SETTINGS}`, { loading })
      if (res.code === 'ok') {
        commit('setLogMgmtData', res.result)
      }
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  async addBeanLogMgmt ({commit, state}) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      res = await this.$axios.$post(state.url, null, {loading: false, successAlert: false})
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  async getLogMgmt ({commit, state}, {id}) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      res = await this.$axios.$get(`${state.url}/${id}`, {loading: false, successAlert: false})
      if (res.code === 'ok') {
        commit('setLogMgmtDialog', res.result[0])
      }
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  async addLogMgmt ({commit, state}) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      const params = {
        device_id_list: _.map(state.logMgmtPageData.device_list, 'device_id'),
        // device_list_name: '',
        log_mng_cm_backup_end_hour: state.logMgmtPageData.log_mng_cm_backup_end_hour,
        log_mng_cm_backup_end_min: state.logMgmtPageData.log_mng_cm_backup_end_min,
        log_mng_cm_backup_start_hour: state.logMgmtPageData.log_mng_cm_backup_start_hour,
        log_mng_cm_backup_start_min: state.logMgmtPageData.log_mng_cm_backup_start_min,
        log_mng_cm_backup_sync_yn: state.logMgmtPageData.log_mng_cm_backup_sync_yn,
        log_mng_cm_retry_ftp_upload_cnt: state.logMgmtPageData.log_mng_cm_retry_ftp_upload_cnt,
        log_mng_cm_delete_ref_retention: state.logMgmtPageData.log_mng_cm_delete_ref_retention,
        log_mng_cm_delete_retent_term: state.logMgmtPageData.log_mng_cm_delete_retent_term,
        log_mng_cm_delete_run_hour: state.logMgmtPageData.log_mng_cm_delete_run_hour,
        log_mng_cm_delete_run_min: state.logMgmtPageData.log_mng_cm_delete_run_min,
        log_mng_cm_delete_sync_yn: state.logMgmtPageData.log_mng_cm_delete_sync_yn,
        log_mng_cm_delete_use_yn: state.logMgmtPageData.log_mng_cm_delete_use_yn,
        log_mng_cm_desc: state.logMgmtPageData.log_mng_cm_desc,
        log_mng_cm_id: state.logMgmtPageData.log_mng_cm_id,
        log_mng_cm_log_set: JSON.stringify(state.logInfoList),
        log_mng_cm_log_opt_set: JSON.stringify(state.logMgmtPageData.log_mng_cm_log_opt_set),
        log_mng_cm_log_sync_set: JSON.stringify(state.logMgmtPageData.log_mng_cm_log_sync_set),
        log_mng_cm_uname: state.logMgmtPageData.log_mng_cm_uname,
        log_mng_cm_usage_max_cnt: state.logMgmtPageData.log_mng_cm_usage_max_cnt,
        log_mng_cm_usage_sync_yn: state.logMgmtPageData.log_mng_cm_usage_sync_yn,
        log_mng_cm_sync_yn: state.logMgmtPageData.log_mng_cm_sync_yn,
        log_mng_cm_device_model_type: state.logMgmtPageData.log_mng_cm_device_model_type
      }

      res = await this.$axios.$put(state.url, params, {loading: false, successAlert: false})
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  async edtLogMgmt ({commit, state}) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      const params = {
        device_id_list: _.map(state.logMgmtPageData.device_list, 'device_id'),
        // device_list_name: '',
        log_mng_cm_backup_end_hour: state.logMgmtPageData.log_mng_cm_backup_end_hour,
        log_mng_cm_backup_end_min: state.logMgmtPageData.log_mng_cm_backup_end_min,
        log_mng_cm_backup_start_hour: state.logMgmtPageData.log_mng_cm_backup_start_hour,
        log_mng_cm_backup_start_min: state.logMgmtPageData.log_mng_cm_backup_start_min,
        log_mng_cm_backup_sync_yn: state.logMgmtPageData.log_mng_cm_backup_sync_yn,
        log_mng_cm_retry_ftp_upload_cnt: state.logMgmtPageData.log_mng_cm_retry_ftp_upload_cnt,
        log_mng_cm_delete_ref_retention: state.logMgmtPageData.log_mng_cm_delete_ref_retention,
        log_mng_cm_delete_retent_term: state.logMgmtPageData.log_mng_cm_delete_retent_term,
        log_mng_cm_delete_run_hour: state.logMgmtPageData.log_mng_cm_delete_run_hour,
        log_mng_cm_delete_run_min: state.logMgmtPageData.log_mng_cm_delete_run_min,
        log_mng_cm_delete_sync_yn: state.logMgmtPageData.log_mng_cm_delete_sync_yn,
        log_mng_cm_delete_use_yn: state.logMgmtPageData.log_mng_cm_delete_use_yn,
        log_mng_cm_desc: state.logMgmtPageData.log_mng_cm_desc,
        log_mng_cm_id: state.logMgmtPageData.log_mng_cm_id,
        log_mng_cm_log_set: JSON.stringify(state.logInfoList),
        log_mng_cm_log_opt_set: JSON.stringify(state.logMgmtPageData.log_mng_cm_log_opt_set),
        log_mng_cm_log_sync_set: JSON.stringify(state.logMgmtPageData.log_mng_cm_log_sync_set),
        log_mng_cm_uname: state.logMgmtPageData.log_mng_cm_uname,
        log_mng_cm_usage_max_cnt: state.logMgmtPageData.log_mng_cm_usage_max_cnt,
        log_mng_cm_usage_sync_yn: state.logMgmtPageData.log_mng_cm_usage_sync_yn,
        log_mng_cm_sync_yn: state.logMgmtPageData.log_mng_cm_sync_yn,
        log_mng_cm_device_model_type: state.logMgmtPageData.log_mng_cm_device_model_type
      }

      res = await this.$axios.$put(state.url, params)
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  async delLogMgmt ({commit, state}, param) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      const isShow = _.has(param, 'isShow') ? param.isShow : true
      const isAlert = _.has(param, 'isAlert') ? param.isAlert : true
      res = await this.$axios.$put(`${state.url}/multi`, param.idList, {
        loading: isShow,
        successAlert: isAlert,
        alertMsg: i18n.t('msg.removeApply')
      })
      if (res.code === 'ok') {
        commit('delLogMgmt', param.idList)
      }
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  async initLogMgmtLogEntitiesSettings ({ commit, state }) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      res = await this.$axios.$get(`${state.url}/log-set/${state.logMgmtPageData.log_mng_cm_device_model_type}/init`, {
        loading: false,
        successAlert: false
      })

      if (res.code === 'ok') {
        commit('setLogMgmtLogEntitiesSettings', res.result)
      }
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  async processLogMgmtSync ({commit, state}, param) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      res = await this.$axios.$post(`${state.url}/multi`, param, {loading: false, isNotAlert: true})
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  // 리스트 조회
  async getAutoBackupData ({commit, state}, { loading = false } = {}) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      const ALL_AUTO_BACKUP_SETTINGS = 0
      res = await this.$axios.$get(`${state.url}/backup-server/${state.logMgmtPageData.log_mng_cm_id}/${ALL_AUTO_BACKUP_SETTINGS}`, {
        loading
      })
      if (res.code === 'ok') {
        commit('setAutoBackupData', res.result)
      }
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  async addAutoBackupData ({commit, dispatch, state, rootState}, { password }) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      const autoBackupData = _.cloneDeep(state.autoBackupData)
      const params = {
        log_mng_cm_backup_server_addr_val: autoBackupData.log_mng_cm_backup_server_addr_val,
        log_mng_cm_backup_server_dir_val: autoBackupData.log_mng_cm_backup_server_dir_val,
        log_mng_cm_backup_server_end_date: Moment(autoBackupData.log_mng_cm_backup_server_end_date).format(DATE_FORMAT),
        log_mng_cm_backup_server_login_name: autoBackupData.log_mng_cm_backup_server_login_name,
        log_mng_cm_backup_server_login_pw: _.get(password, ['length'], 0) > 0 ? password : null,
        log_mng_cm_backup_server_port: autoBackupData.log_mng_cm_backup_server_port,
        log_mng_cm_backup_server_prtc_type: autoBackupData.log_mng_cm_backup_server_prtc_type,
        log_mng_cm_backup_server_file_format: autoBackupData.log_mng_cm_backup_server_file_format,
        log_mng_cm_backup_server_method: autoBackupData.log_mng_cm_backup_server_method,
        log_mng_cm_backup_server_start_date: Moment(autoBackupData.log_mng_cm_backup_server_start_date).format(DATE_FORMAT),
        log_mng_cm_backup_server_term: autoBackupData.log_mng_cm_backup_server_term,
        log_mng_cm_backup_server_type: autoBackupData.log_mng_cm_backup_server_type,
        log_mng_cm_backup_server_use_yn: autoBackupData.log_mng_cm_backup_server_use_yn,
        log_mng_cm_id: state.logMgmtPageData.log_mng_cm_id
      }

      res = await this.$axios.$post(`${state.url}/backup-server`, params, {loading: false})
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  async edtAutoBackupData ({commit, state}, { password }) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      const autoBackupData = _.cloneDeep(state.autoBackupData)
      const params = {
        log_mng_cm_backup_server_addr_val: autoBackupData.log_mng_cm_backup_server_addr_val,
        log_mng_cm_backup_server_dir_val: autoBackupData.log_mng_cm_backup_server_dir_val,
        log_mng_cm_backup_server_end_date: Moment(state.autoBackupData.log_mng_cm_backup_server_end_date).format(DATE_FORMAT),
        log_mng_cm_backup_server_id: autoBackupData.log_mng_cm_backup_server_id,
        log_mng_cm_backup_server_login_name: autoBackupData.log_mng_cm_backup_server_login_name,
        log_mng_cm_backup_server_login_pw: _.get(password, ['length'], 0) > 0 ? password : null,
        log_mng_cm_backup_server_port: autoBackupData.log_mng_cm_backup_server_port,
        log_mng_cm_backup_server_prtc_type: autoBackupData.log_mng_cm_backup_server_prtc_type,
        log_mng_cm_backup_server_file_format: autoBackupData.log_mng_cm_backup_server_file_format,
        log_mng_cm_backup_server_method: autoBackupData.log_mng_cm_backup_server_method,
        log_mng_cm_backup_server_start_date: Moment(state.autoBackupData.log_mng_cm_backup_server_start_date).format(DATE_FORMAT),
        log_mng_cm_backup_server_term: autoBackupData.log_mng_cm_backup_server_term,
        log_mng_cm_backup_server_type: autoBackupData.log_mng_cm_backup_server_type,
        log_mng_cm_backup_server_use_yn: autoBackupData.log_mng_cm_backup_server_use_yn
      }

      res = await this.$axios.$put(`${state.url}/backup-server`, params, {loading: false})
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.meesage
    }
    return res
  },
  async delAutoBackupData ({commit, state}, {id}) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      res = await this.$axios.$delete(`${state.url}/backup-server/${id}`)
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.meesage
    }
    return res
  },
  async processBackupServerUse ({commit, state}, param) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      res = await this.$axios.$put(`${state.url}/backup-server/multi`, param, {loading: false, isNotAlert: true})
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.meesage
    }
    return res
  },
  async finalCommand ({state}, type) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      const axiosConfig = (type === 'apply') ? {applyMsg: true} : {cancelMsg: true}
      res = await this.$axios.$put(`${state.url}/${type}`, void 0, axiosConfig)
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.meesage
    }
    return res
  }
}

export const getters = {}

export const strict = false
